import React from 'react';

const LineInfoSvg = ({ size = 18 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z" />
    <path d="M9 8.25V12" />
    <path d="M9 6.6C9.33137 6.6 9.6 6.33137 9.6 6C9.6 5.66863 9.33137 5.4 9 5.4C8.66863 5.4 8.4 5.66863 8.4 6C8.4 6.33137 8.66863 6.6 9 6.6Z" />
  </svg>
);

export default LineInfoSvg;
